import React from 'react'

export default function Margin() {
  return (
    <>
      <h1>Margin</h1>
      <p>There are several classes to quickly and easily apply margin styles to elements. </p>
    
      <h2>Complete Margins</h2>
      <p>These apply margins to all sides of the element: top, right, bottom and left</p>
      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;p class="bc-blue m-0"&gt;m-0&lt;/p&gt;<br />
            &lt;p class="bc-blue m-1"&gt;m-1&lt;/p&gt;<br />
            &lt;p class="bc-blue m-2"&gt;m-2&lt;/p&gt;<br />
            &lt;p class="bc-blue m-3"&gt;m-3&lt;/p&gt;<br />
            &lt;p class="bc-blue m-4"&gt;m-4&lt;/p&gt;<br />
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
        <p className="bc-blue m-0">m-0</p>
        <p className="bc-blue m-1">m-1</p>
        <p className="bc-blue m-2">m-2</p>
        <p className="bc-blue m-3">m-3</p>
        <p className="bc-blue m-4">m-4</p>

      </div>

      <h2>Margin X-axis</h2>
      <p>These apply margins to both the left and right side</p>
      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;p class="bc-blue mx-0"&gt;mx-0&lt;/p&gt;<br />
            &lt;p class="bc-blue mx-1"&gt;mx-1&lt;/p&gt;<br />
            &lt;p class="bc-blue mx-2"&gt;mx-2&lt;/p&gt;<br />
            &lt;p class="bc-blue mx-3"&gt;mx-3&lt;/p&gt;<br />
            &lt;p class="bc-blue mx-4"&gt;mx-4&lt;/p&gt;<br />
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
        <p className="bc-blue mx-0">mx-0</p>
        <p className="bc-blue mx-1">mx-1</p>
        <p className="bc-blue mx-2">mx-2</p>
        <p className="bc-blue mx-3">mx-3</p>
        <p className="bc-blue mx-4">mx-4</p>
      </div>

      <h2>Margin Y-axis</h2>
      <p>These apply margins to both the top and bottom side</p>
      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;p class="bc-blue my-0"&gt;my-0&lt;/p&gt;<br />
            &lt;p class="bc-blue my-1"&gt;my-1&lt;/p&gt;<br />
            &lt;p class="bc-blue my-2"&gt;my-2&lt;/p&gt;<br />
            &lt;p class="bc-blue my-3"&gt;my-3&lt;/p&gt;<br />
            &lt;p class="bc-blue my-4"&gt;my-4&lt;/p&gt;<br />
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
        <p className="bc-blue my-0">my-0</p>
        <p className="bc-blue my-1">my-1</p>
        <p className="bc-blue my-2">my-2</p>
        <p className="bc-blue my-3">my-3</p>
        <p className="bc-blue my-4">my-4</p>
      </div>

      <h2>Margin Left & Margin Right</h2>
      <p><span className='tag-grey bold'>.ml-(number 0-4)</span> class applys margins to the left side</p>
      <p><span className='tag-grey bold'>.mr-(number 0-4)</span> class applys margins to the right side</p>
      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;p class="bc-blue ml-0"&gt;ml-0&lt;/p&gt;<br />
            &lt;p class="bc-blue ml-1"&gt;ml-1&lt;/p&gt;<br />
            &lt;p class="bc-blue ml-2"&gt;ml-2&lt;/p&gt;<br />
            &lt;p class="bc-blue ml-3"&gt;ml-3&lt;/p&gt;<br />
            &lt;p class="bc-blue ml-4"&gt;ml-4&lt;/p&gt;<br />
            &lt;p class="bc-blue mr-0"&gt;mr-0&lt;/p&gt;<br />
            &lt;p class="bc-blue mr-1"&gt;mr-1&lt;/p&gt;<br />
            &lt;p class="bc-blue mr-2"&gt;mr-2&lt;/p&gt;<br />
            &lt;p class="bc-blue mr-3"&gt;mr-3&lt;/p&gt;<br />
            &lt;p class="bc-blue mr-4"&gt;mr-4&lt;/p&gt;<br />
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
        <p className="bc-blue ml-0">ml-0</p>
        <p className="bc-blue ml-1">ml-1</p>
        <p className="bc-blue ml-2">ml-2</p>
        <p className="bc-blue ml-3">ml-3</p>
        <p className="bc-blue ml-4">ml-4</p>
        <p className="bc-blue mr-0">mr-0</p>
        <p className="bc-blue mr-1">mr-1</p>
        <p className="bc-blue mr-2">mr-2</p>
        <p className="bc-blue mr-3">mr-3</p>
        <p className="bc-blue mr-4">mr-4</p>
      </div>

      <h2>Margin Top & Margin Bottom</h2>
      <p><span className='tag-grey bold'>.mt-(number 0-4)</span> class applys margins to the top side</p>
      <p><span className='tag-grey bold'>.mb-(number 0-4)</span> class applys margins to the bottom side</p>      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;p class="bc-blue mt-0"&gt;mt-0&lt;/p&gt;<br />
            &lt;p class="bc-blue mt-1"&gt;mt-1&lt;/p&gt;<br />
            &lt;p class="bc-blue mt-2"&gt;mt-2&lt;/p&gt;<br />
            &lt;p class="bc-blue mt-3"&gt;mt-3&lt;/p&gt;<br />
            &lt;p class="bc-blue mt-4"&gt;mt-4&lt;/p&gt;<br />
            &lt;p class="bc-blue mb-0"&gt;mb-0&lt;/p&gt;<br />
            &lt;p class="bc-blue mb-1"&gt;mb-1&lt;/p&gt;<br />
            &lt;p class="bc-blue mb-2"&gt;mb-2&lt;/p&gt;<br />
            &lt;p class="bc-blue mb-3"&gt;mb-3&lt;/p&gt;<br />
            &lt;p class="bc-blue mb-4"&gt;mb-4&lt;/p&gt;<br />
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
        <p className="bc-blue mt-0">mt-0</p>
        <p className="bc-blue mt-1">mt-1</p>
        <p className="bc-blue mt-2">mt-2</p>
        <p className="bc-blue mt-3">mt-3</p>
        <p className="bc-blue mt-4">mt-4</p>
        <p className="bc-blue mb-0">mb-0</p>
        <p className="bc-blue mb-1">mb-1</p>
        <p className="bc-blue mb-2">mb-2</p>
        <p className="bc-blue mb-3">mb-3</p>
        <p className="bc-blue mb-4">mb-4</p>
      </div>

      <h2>Margin Items Classes</h2>
      <p> These classes add a set margin to all the child elements of this class</p>
      <ul className='mb-items-1'>
        <li><span className='tag-grey bold'>.m-items-(number 0-4)</span> class applys margins to the all sides of all child elements</li>
        <li><span className='tag-grey bold'>.mt-items-(number 0-4)</span> class applys margins to the top side of all child element</li>
        <li><span className='tag-grey bold'>.mb-items-(number 0-4)</span> class applys margins to the bottom side of all child element</li>
        <li><span className='tag-grey bold'>.ml-items-(number 0-4)</span> class applys margins to the left side of all child element</li>
        <li><span className='tag-grey bold'>.mr-items-(number 0-4)</span> class applys margins to the right side of all child element</li>
        <li><span className='tag-grey bold'>.mx-items-(number 0-4)</span> class applys margins to the left annd right side of all child element</li>
        <li><span className='tag-grey bold'>.my-items-(number 0-4)</span> class applys margins to the top and bottom side of all child element</li>
      </ul>
    </>
  )
}
